import React, { Component } from "react";
import DashboardHost from "./DashboardHost";
import type { DrillContext } from "../../components/dashdrill/types";
import { DrillSession } from "../services/DrillSession";
import { bizpost } from "../../ajax";
import { DashboardDrillRequest, DashboardFilterOptions, DashboardSharedFilters } from "./dashboard.types";
import { defaultDashboardKey } from "./dashboardRegistry";
import DashboardDrillHost from "./DashboardDrillHost";


interface Props {
  handleSetContent?: (e: any, v: any, s?: boolean) => Promise<any>;
  userData?: any;
  code?: string;
}

interface State {
  //activeDashboard: string;
  activeDashboardKey: string;
  pendingDashboardKey?: string | null;
  dashData: any,
  loading: boolean;
  error: string | null;
  sharedFilters: Partial<DashboardSharedFilters>;
  filterOptions: Partial<DashboardFilterOptions>;
  drillOpen: boolean;
  drillRequest?: DashboardDrillRequest | null;
}

export default class DashboardCenter extends Component<Props,State> {
  
  state = {
    //activeDashboard: 'executive',
    activeDashboardKey: defaultDashboardKey,
    pendingDashboardKey: undefined,
    loading: false,
    error: "",
    dashData: {
      meta: {},
      sections: {},
      summaryCards: [],

    },
    sharedFilters: {
      period: '2025',
      cycle: 'FORM',
      scenario: 'REVIS',
      costcenter: undefined,
      location: undefined,
      asofdate: '2025-06-30',
    },

    filterOptions: {
      periods: [],
      cycles: [],
      scenarios: [],
      costcenters: [],
      locations: [],
    },

    drillOpen: false,
    drillRequest: null as DashboardDrillRequest | null,

  };

  componentDidMount() {
    this.loadFilterOptions();
    this.handleRefreshDashboard();
  }

  private loadFilterOptions = async () => {
    console.log("load Filter Options");
    // Plug your real export / API orchestration here later

    // const { meta,tabs, timer, count:rcount,recent:rcn,offset:ofs,limit:lim } = this.state;

    const baseparams = { s: "dashboard", a: "filters",};
    const response = await bizpost(baseparams);
    console.log('lfo.response:',response);
    const {sd:data} = response;
    let options:any = {};
    Object.keys(data).map((key:any)=>{
      if(data[key] && data[key].length > 0){
        options[key] = data[key];
      }
    });
    this.setState({filterOptions:options});
  };

  // handleFilterChange1 = (patch: Partial<DashboardSharedFilters>) => {
  //   this.setState(prev => ({
  //     sharedFilters: {
  //       ...prev.sharedFilters,
  //       ...patch,
  //     },
  //   }));
  // };

  handleFilterChange = (patch: Partial<DashboardSharedFilters>) => {
    this.setState(
      prev => ({
        sharedFilters: {
          ...prev.sharedFilters,
          ...patch,
        },
      }),
      () => this.handleRefreshDashboard(this.state.activeDashboardKey)
    );
  };

  fetchDashboardData = async (dashboardKey: string) => {
    const { sharedFilters } = this.state;

    const response = await bizpost({
      s: "dashboard",
      a: "get",
      mod: dashboardKey,
      bpc: sharedFilters.period,
      bcc: sharedFilters.cycle,
      scc: sharedFilters.scenario,
      ccc: sharedFilters.costcenter,
      lcc: sharedFilters.location,
      asd: sharedFilters.asofdate,
      // mod: dashboardKey,
      // bpc: sharedFilters.period || null,
      // bcc: sharedFilters.cycle || null,
      // scc: sharedFilters.scenario || null,
      // ccc: sharedFilters.costcenter || null,
      // lcc: sharedFilters.location || null,
      // asd: sharedFilters.asofdate || null,
    });

    return response.sd;
  };

  handleRefreshDashboard = async (dashboardKey?: string) => {
    //const key = dashboardKey || this.state.activeDashboardKey;
    console.log('refresh init: ',dashboardKey);

    const {activeDashboardKey:key} = this.state;
    console.log('refresh start: ',key);

    this.setState({ loading: true, error: null });

    try {
      const data = await this.fetchDashboardData(key);
      console.log('refresh success: ',key);

      this.setState({
        dashData: data,
        loading: false,
      });
    } catch (err: any) {
      this.setState({
        loading: false,
        error: err?.message || "Unable to refresh dashboard",
      });
    }
  };

  // private handleRefreshDashboard2 = async (dashboardKey?: string) => {
  //   const key = dashboardKey || this.state.activeDashboardKey || defaultDashboardKey;
  //   const { sharedFilters } = this.state;

  //   console.log('refreshing ',key);

  //   const baseparams = {
  //     s: "dashboard",
  //     a: "get",
  //     mod: key,
  //     bpc: sharedFilters.period || null,
  //     bcc: sharedFilters.cycle || null,
  //     scc: sharedFilters.scenario || null,
  //     ccc: sharedFilters.costcenter || null,
  //     lcc: sharedFilters.location || null,
  //     asd: sharedFilters.asofdate || null,
  //   };

  //   const response = await bizpost(baseparams);
  //   const { rc, sd: data = {} } = response;
  //   console.log('refreshed ',key,' rc= ',rc);

  //   this.setState({
  //     activeDashboard: key,
  //     dashData: data,
  //   });
  // };

  handleExportDashboard = async() => {
    //const { activeDashboard, dashboardData } = this.state;
    const { activeDashboardKey, dashData:dashboardData } = this.state;
    const blob = new Blob([JSON.stringify(dashboardData, null, 2)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${activeDashboardKey}-dashboard.json`;
    a.click();
    URL.revokeObjectURL(url);

  };

  handleDashboardChange = async (key: string) => {
    const previousKey = this.state.activeDashboardKey;

    if (key === previousKey) return;

    this.setState({
      loading: true,
      pendingDashboardKey: key,
      error: null,
    });

    try {
      const data = await this.fetchDashboardData(key);

      this.setState({
        activeDashboardKey: key,
        pendingDashboardKey: null,
        dashData: data,
        loading: false,
      });
    } catch (err: any) {
      this.setState({
        activeDashboardKey: previousKey,
        pendingDashboardKey: null,
        loading: false,
        error: err?.message || "Unable to load dashboard",
      });
    }
  };

  private handleDashboardDrill = async (target: string, context: DrillContext) => {
    const normalized = (target || "").replace(/^\/+/, "");

    if (normalized.startsWith("analytics/")) {
      DrillSession.set({
        page: "analytics",
        targetKey: normalized.replace("analytics/", ""),
        context,
        stamp: Date.now(),
      });
      if (this.props.handleSetContent) {
        await this.props.handleSetContent(null, "analyticscenter");
      }
      return;
    }

    if (normalized.startsWith("service/")) {
      DrillSession.set({
        page: "service",
        targetKey: normalized.replace("service/", ""),
        context,
        stamp: Date.now(),
      });
      if (this.props.handleSetContent) {
        await this.props.handleSetContent(null, "drillservice");
      }
      return;
    }

    if (normalized.startsWith("dashboard/")) {
      DrillSession.set({
        page: "dashboard",
        targetKey: normalized.replace("dashboard/", ""),
        context,
        stamp: Date.now(),
      });
      if (this.props.handleSetContent) {
        await this.props.handleSetContent(null, "dashboard");
      }
      return;
    }
  };

  onDashboardDrill = (request: DashboardDrillRequest) => {
    this.setState({
      drillOpen: true,
      drillRequest: request,
    });
  };

  handleCloseDrill = () => {
    this.setState({
      drillOpen: false,
      drillRequest: null,
    });
  };

  render() {
    const {userData} = this.props;
    const {dashData,sharedFilters,filterOptions} = this.state;
    const {activeDashboardKey,pendingDashboardKey,loading} = this.state;

    return (
      <>

        <DashboardHost
          userData={userData}
          dashData={dashData}
          activeDashboardKey={activeDashboardKey}
          pendingDashboardKey={pendingDashboardKey}
          loading={loading}
          //activeDashboardKey={activeDashboardKey}
          sharedFilters={sharedFilters}
          filterOptions={filterOptions}
          onDashboardChange={this.handleDashboardChange}
          onFilterChange={this.handleFilterChange}
          onRefresh={this.handleRefreshDashboard}
          onExport={this.handleExportDashboard}
          navigateToDrill={this.handleDashboardDrill}
        />

        {/* <UnifiedDrillHost
          open={this.state.drillOpen}
          request={this.state.drillRequest}
          onClose={this.handleCloseDrill}
        /> */}

        <DashboardDrillHost
          open={this.state.drillOpen}
          request={this.state.drillRequest}
          onClose={this.handleCloseDrill}
        />
      </>
    );
  }
}
